/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';

import { PresenceService } from './pages/extra-components/chat/presence.service';
import { SessionTimeoutService } from './services/session-timeout.service';
import { NetworkDiagnosticsService } from './services/network-diagnostics.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {

  constructor(
    private presence: PresenceService,
    private sessionTimeout: SessionTimeoutService,
    private networkDiagnostics: NetworkDiagnosticsService
  ) {
    this.networkDiagnostics.init();
    this.sessionTimeout.init();
  }


}
